import moment from 'moment'
import { DataService } from '@/services/DataService.js'
import Vue from 'vue'
export const namespaced = true

function getPeriodType (periodType) {
  switch (periodType) {
    case 'decade': return 'days'
    default: return periodType + 's'
  }
}

function dateOffset (periodType) {
  switch (periodType) {
    case 'decade': return 10
    default: return 1
  }
}

function format (periodType) {
  switch (periodType) {
    case 'month': return 'MMM'
    case 'week': return 'Нww'
    case 'quarter': return 'КQ'
    default: return 'DD'
  }
}

async function loadReportByName (reportName, params) {
  // В зависимости от названия отчёта вызываем нужный метод
  switch (reportName) {
    case 'tendersCount': {
      return DataService.getTendersCount(params)
    }
    case 'tendersSum': {
      return DataService.getTendersSum(params)
    }
    case 'offersCount': {
      return DataService.getOffersCount(params)
    }
    case 'tendersAvgTimeSpending': {
      return DataService.getTendersAvgTimeSpending(params)
    }
    case 'tendersAvgTimeDuration': {
      return DataService.getTendersAvgTimeDuration(params)
    }
    case 'countCompaniesInvitedByOrg': {
      return DataService.getCountCompaniesInvitedByOrg(params)
    }
    case 'countCompaniesInvitedByTpro': {
      return DataService.getCountCompaniesInvitedByTpro(params)
    }
    case 'providersTop10': {
      return DataService.getProvidersTop10(params)
    }
    case 'criticalIndicators': {
      return DataService.getCriticalIndicators(params)
    }
    case 'economicEfficiency': {
      return DataService.getEconomicEfficiency(params)
    }
    default: {
      console.error('Unknown reportName:', reportName)
    }
  }
}

export const state = {
  data: null,
  dates: [],
  dateRange: {
    start: moment().startOf('year').toDate(),
    end: moment().endOf('month').toDate()
  },
  startDate: null,
  periodType: 'month',
  format: format('month'),
  periods: [
    { id: 0, code: 'day', name: 'дням' },
    { id: 1, code: 'week', name: 'неделям' },
    { id: 2, code: 'decade', name: 'декадам' },
    { id: 3, code: 'month', name: 'месяцам' },
    { id: 4, code: 'quarter', name: 'кварталам' }
  ]
}

export const mutations = {
  PUSH (state, data) {
    state.data = { ...state.data, ...data.indicators }
  },
  SET_DATE_RANGE (state, dr) {
    state.dateRange = dr
  },
  SET_PERIOD (state, p) {
    state.periodType = p
  },
  CLEAN (state) {
    state.data = null
    state.format = format(state.periodType)
  },
  CLEAN_REPORT (state, reportName) {
    // Очищаем результат одного отчёта
    if (state.data) {
      Vue.delete(state.data, reportName)
    }
  },
  LOADING_REPORT (state, reportName) {
    // Выставляем отчёту значение 'loading'
    if (state.data == null) {
      state.data = {}
    }
    Vue.set(state.data, reportName, 'loading')
  },
  UPDATE_DATES (state) {
    const { dateRange, periodType } = state
    const dates = []
    const period = getPeriodType(periodType)
    const offset = dateOffset(periodType)
    for (let dt = moment(dateRange.start); dt.isSameOrBefore(dateRange.end); dt.add(offset, period)) {
      dates.push(dt.clone())
    }
    state.dates = dates
  }
}

export const actions = {
  async loadReports ({ commit, state }, requestedReports) {
    const { dateRange, periodType } = state
    if (!dateRange) return
    commit('UPDATE_DATES')

    const params = {
      from: moment(dateRange.start).format('YYYY-MM-DD'),
      to: moment(dateRange.end).format('YYYY-MM-DD'),
      periodType
    }
    requestedReports.forEach(function (reportName) {
      // Очищаем предыдущие данные по отчёту
      commit('CLEAN_REPORT', reportName)
      // Выставляем значение 'loading'
      commit('LOADING_REPORT', reportName)
      // Идём загружать данные
      loadReportByName(reportName, params)
        .then(({ data }) => commit('PUSH', data))
        .catch(({ data }) => commit('PUSH', { indicators: { [reportName]: 'error' } }))
    })

    return Promise.resolve({})
  },
  async get_data ({ commit, dispatch }) {
    // В этой функции производится загрузка всех интересующих отчётов
    commit('CLEAN')
    const reportsToLoad = [
      'economicEfficiency', 'tendersCount', 'tendersSum', 'offersCount',
      'tendersAvgTimeSpending', 'tendersAvgTimeDuration', 'countCompaniesInvitedByOrg',
      'countCompaniesInvitedByTpro', 'providersTop10', 'criticalIndicators'
    ]
    return dispatch('loadReports', reportsToLoad)
  },
  async updateDateRange ({ commit, dispatch }, dr) {
    await commit('SET_DATE_RANGE', dr)
  },
  async updatePeriod ({ commit, dispatch }, p) {
    await commit('SET_PERIOD', p)
  }
}

export const getters = {
  data (state) {
    return state.data
  },
  dateRange (state) {
    return state.dateRange
  },
  periods (state) {
    return state.periods
  },
  periodType (state) {
    return state.periodType
  },
  periodLabel (state) {
    return state.periods.find(p => p.code === state.periodType).name
  },
  dates (state) {
    return state.dates
  },
  format () {
    return state.format
  },
  label (state, getters) {
    return (offset) => {
      // % hack для демо режима
      return getters.dates[offset % getters.dates.length].format(getters.format)
    }
  }
}
